import { render } from "./TeamLogoChip.vue?vue&type=template&id=6a5d842a"
import script from "./TeamLogoChip.vue?vue&type=script&lang=js"
export * from "./TeamLogoChip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__